var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "accordion",
      class: [{ collapsed: _vm.collapsed }, _vm.accordionClasses]
    },
    [
      _c(
        "div",
        {
          staticClass: "accordion__top mg mg--b-4",
          on: {
            click: function($event) {
              return _vm.toggleAccordion($event)
            }
          }
        },
        [
          _vm._t("accordionTop"),
          _c("svgicon", { attrs: { icon: "arrow_right", width: "18" } })
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "accordion__bottom" },
        [_vm._t("accordionBottom")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }